module.exports = __webpack_public_path__ + "img/7.21166a0f.png";